import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/LmPathwayApi/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */

/**
 * Lists available pathways
 */
export const listPathways = () => {
  return instance.get( "ListPathways" );
};

/*
 * Lists the pathways available to the user
 */
export const listUserPathways = () => {
  return instance.get( "ListUserPathways" );
};

/**
 * Loads a single pathway steps
 */
export const loadPathway = ( id ) => {
  return instance.get( `LoadPathway?id=${id}` );
};

/*
 * Loads a users pathway steps
 */
export const loadUserPathway = ( id ) => {
  return instance.get( `LoadUserPathway?id=${id}` );
};

/*
 * Assigns a pathway to a user's account
 */
export const assignPathwayToUser = ( id ) => {
  return instance.post( "AssignPathwayToUser", `"${id}"` );
};

/*
 * Posts data to the queue when a user requests a certificate for a completed pathway
 */
export const requestCertificate = ( id ) => {
  return instance.post( "RequestCertificate", `"${id}"` );
};

/*
 * Checks whether the pathway has been completed or not
 */
export const checkPathwayCompletion = ( id ) => {
  return instance.post( "CheckPathwayCompletion", `"${id}"` );
};

/*
 * Gets the umbraco content url matching the ID
 */
export const getPathwayUrl = ( id ) => {
  return instance.get( `GetPathwayUrl?id=${id}` );
};

/*
 * Gets the umbraco cms data from the back office
 */
export const getCmsPathwayData = () => {
  return instance.get( "ListCmsPathwayData" );
};
